module.exports = __webpack_public_path__ + "fonts/Inter-700-cyrillic-ext64.251d36f.woff2";